import { useContextSelector } from 'use-context-selector';
import { useAssetId } from '../../../shared';
import { DndOpsContext } from '../contexts/DndOpsContext';
import { useAssetDndZone } from '../contexts/DndZoneContext';

export const useIsAssetDragging = () => {
  const assetId = useAssetId();
  const zone = useAssetDndZone();
  return useContextSelector(
    DndOpsContext,
    ({ active, draggingIds }) =>
      draggingIds.has(assetId) && active?.zone === zone
  );
};
